export default __webpack_public_path__ + "static/small-image-norsk-2-2e6397504af5c37b4432ef2d18fa2b73.png";